import { v0 } from 'src/reducers/migrations/v0';
import { v1 } from 'src/reducers/migrations/v1';
import { v10 } from 'src/reducers/migrations/v10';
import { v11 } from 'src/reducers/migrations/v11';
import { v12 } from 'src/reducers/migrations/v12';
import { v13 } from 'src/reducers/migrations/v13';
import { v14 } from 'src/reducers/migrations/v14';
import { v15 } from 'src/reducers/migrations/v15';
import { v16 } from 'src/reducers/migrations/v16';
import { v17 } from 'src/reducers/migrations/v17';
import { v18 } from 'src/reducers/migrations/v18';
import { v19 } from 'src/reducers/migrations/v19';
import { v2 } from 'src/reducers/migrations/v2';
import { v20 } from 'src/reducers/migrations/v20';
import { v21 } from 'src/reducers/migrations/v21';
import { v22 } from 'src/reducers/migrations/v22';
import { v23 } from 'src/reducers/migrations/v23';
import { v24 } from 'src/reducers/migrations/v24';
import { v25 } from 'src/reducers/migrations/v25';
import { v26 } from 'src/reducers/migrations/v26';
import { v27 } from 'src/reducers/migrations/v27';
import { v3 } from 'src/reducers/migrations/v3';
import { v4 } from 'src/reducers/migrations/v4';
import { v5 } from 'src/reducers/migrations/v5';
import { v6 } from 'src/reducers/migrations/v6';
import { v7 } from 'src/reducers/migrations/v7';
import { v8 } from 'src/reducers/migrations/v8';
import { v9 } from 'src/reducers/migrations/v9';
import { ReduxState } from 'src/store/types';

export const CURRENT_MIGRATION_VERSION = 27;

// input state must be typed as `any` since it's an older version of the Redux State
export const MIGRATION_MANIFEST: Record<number, (state: any) => ReduxState> = {
  0: v0,
  1: v1,
  2: v2,
  3: v3,
  4: v4,
  5: v5,
  6: v6,
  7: v7,
  8: v8,
  9: v9,
  10: v10,
  11: v11,
  12: v12,
  13: v13,
  14: v14,
  15: v15,
  16: v16,
  17: v17,
  18: v18,
  19: v19,
  20: v20,
  21: v21,
  22: v22,
  23: v23,
  24: v24,
  25: v25,
  26: v26,
  27: v27,
};
